import { useEffect } from "react";
import { TextField, MenuItem } from "@mui/material";
import useProductSizes from "../hooks/useProductSizes";

const SizeSelector = ({ value, onChange, hiddenLabel = false }) => {
  const { sizes } = useProductSizes();

  useEffect(() => {
    if (!sizes.length || !value) return;

    const numericSize = Number(value);
    const exists = sizes.some((s) => Number(s.value) === numericSize);

    if (!exists) onChange("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, sizes]);

  return (
    <TextField
      select
      size="small"
      label={hiddenLabel ? "" : "Size"}
      fullWidth
      value={value || ""}
      onChange={(e) => {
        const v = e.target.value;
        onChange(v === "" ? "" : Number(v));
      }}
      disabled={!sizes.length}
    >
      <MenuItem value="">
        —
      </MenuItem>
      {sizes.map((s) => (
        <MenuItem key={s.value} value={s.value}>
          {s.name}
        </MenuItem>
      ))}
    </TextField>
  );
};

export default SizeSelector;
